// @flow
import * as React from 'react';
import moment from 'moment-timezone';
import theme from './FixedDate.scss';
import DateTimeUtils, { DateStyle } from 'common/utils/DateTimeUtils';

type Props = {
    headerSize: number,
    visibleTimeStart: number,
    scale: number,
    scaleFactor: number,
    shift: number
};

const LEFT_POSITION = 28;

class FixedDate extends React.PureComponent<Props, void> {
    render() {
        var {
            headerSize,
            visibleTimeStart,
            scale,
            scaleFactor,
            shift
        } = this.props;
        var effectiveScale = scale * (1 / scaleFactor);
        var timePoint = moment(
            visibleTimeStart + (shift + LEFT_POSITION) * effectiveScale
        );
        return (
            <div
                className={theme.date}
                style={{
                    top: headerSize,
                    position: 'absolute',
                    left: LEFT_POSITION,
                    textAlign: 'center'
                }}
            >
                {DateTimeUtils.format(timePoint, {
                    dateStyle: DateStyle.SMALL
                })}
            </div>
        );
    }
}

export default FixedDate;
